import {
  handleBeforeUnload,
  handleUnload,
  handleVisibilityChange,
} from "../../Login/functions/handlePage";

export const directReload = (direct: boolean = true) => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
  window.removeEventListener("unload", handleUnload);
  window.removeEventListener("pagehide", handleUnload);
  document.removeEventListener("visibilitychange", handleVisibilityChange);
  if (direct) window.location.reload();
};
